import { Metadata } from '../../../../utils/spds/metadata';
import Super from '../../core/button.gjs';
import styles from './secondary.module.scss';

const METADATA = Metadata.define({
  description: `
    Secondary button used to perform an action.

    Extends the SPDS Core Button component.
  `,
  name: 'Secondary Button',
});

export default class SpdsActionButtonSecondary extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-button spds-action-button';
  variantClass = 'spds-action-button-secondary';
  variantStyles = styles;
}

export const ACTION_BUTTON_SECONDARY_METADATA = SpdsActionButtonSecondary.metadata;
